import React, { lazy } from "react";
import { Routes, Navigate, Route } from "react-router-dom";
import config from "../config";
import Loadable from "../components/Loadable";
import MainLayout from "../layouts/MainLayout";
import PrivateRoute from "../components/PrivateRoute";

// Auth Pages
const LoginPage = Loadable(lazy(() => import("../views/auth/Login")));
const HomePage = Loadable(lazy(() => import("../views/HomePage/home.page")));
const ViewPage = Loadable(lazy(() => import("../views/ViewPage/view.page")));
const ExtractPage = Loadable(lazy(() => import("../views/ExtractPage/extract.page")));

//-----------------------|| ROUTING RENDER ||-----------------------//
const AppRoutes = () => {
  return (
    <Routes>
      {/* Main Routes */}
      <Route path="/" element={<Navigate replace to={config.defaultPath} />} />

      <Route
        path="app"
        element={
          <PrivateRoute>
            <MainLayout />
          </PrivateRoute>
        }
      >
        <Route path="home" element={<ExtractPage />} />
        <Route path="search" element={<HomePage />} />
        <Route path="project/:id" element={<ViewPage />} />
      </Route>

      {/* Auth Routes */}
      <Route path="/login" element={<LoginPage />} />
    </Routes>
  );
};

export default AppRoutes;
